import { createStore } from 'satcheljs';
import PersonaPhotoState from './schema/PersonaPhotoState';
import { ObservableMap } from 'mobx';

export let personaPhotoStore = createStore<PersonaPhotoState>('personaPhotoStore', {
    personaPhotoUrls: new ObservableMap<string, string>(),
})();
